import { getFontTokenStyle, getColorToken, spacing } from '@koaly/mixins';
import styled from 'styled-components';

const Caption = styled.figcaption `
  ${getFontTokenStyle('caption', 'medium')};
  color: ${getColorToken('800', 'primary')};
  text-align: right;
  margin-top: ${spacing(6)};
`;

export { Caption };
//# sourceMappingURL=Caption.js.map
